import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import Home from "./pages/Home";
import TravelJournal from "./pages/TravelJournal";
import Packages from "./pages/Packages";
import Destinations from "./pages/Destinations";
import DestinationDetail from "./pages/DestinationDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import Legal from "./pages/Legal";
import { SiteProvider } from "./context/SiteContext";
import { AdminAuthProvider } from "./admin/AuthContext";
import AdminLogin from "./admin/pages/Login";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/pages/Dashboard";
import Images from "./admin/pages/Images";
import DestinationsManager from "./admin/pages/DestinationsManager";
import PackagesManager from "./admin/pages/PackagesManager";
import GalleryManager from "./admin/pages/GalleryManager";
import BlogManager from "./admin/pages/BlogManager";
import Enquiries from "./admin/pages/Enquiries";
import Settings from "./admin/pages/Settings";
import InstagramManager from "./admin/pages/InstagramManager";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function PublicSite() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/journal" element={<TravelJournal />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/destinations/:slug" element={<DestinationDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking/:id" element={<Booking />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <FloatingActions />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <SiteProvider>
          <BrowserRouter>
            <AdminAuthProvider>
              <ScrollToTop />
              <Routes>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="images" element={<Images />} />
                  <Route path="destinations" element={<DestinationsManager />} />
                  <Route path="packages" element={<PackagesManager />} />
                  <Route path="gallery" element={<GalleryManager />} />
                  <Route path="blog" element={<BlogManager />} />
                  <Route path="enquiries" element={<Enquiries />} />
                  <Route path="instagram" element={<InstagramManager />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
                <Route path="/*" element={<PublicSite />} />
              </Routes>
              <Toaster position="top-center" richColors />
            </AdminAuthProvider>
          </BrowserRouter>
        </SiteProvider>
      </div>
    </ThemeProvider>
  );
}
